import { Component, OnInit } from '@angular/core';
import { MenuInfoService } from '../../../services/menu-info.service';
import {
  ListStructure,
  SuggestionRequest,
} from '../../../interfaces/menu-info.interface';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../services/auth.service';
import { environment } from '../../../../environments/environment';
import { NotificationComponent } from '../../../paginas/pagos/pagos-online/helpers/notification.component';
import { GoogleAnalyticsService } from '../../../services/google-analytics/google-analytics.service';

@Component({
  selector: 'app-buzon',
  standalone: true,
  imports: [CommonModule, FormsModule, NotificationComponent],
  templateUrl: './buzon.component.html',
  styleUrl: './buzon.component.css',
})
export class BuzonComponent implements OnInit {
  tiposContacto: ListStructure[] = [];
  tiposSugerencia: ListStructure[] = [];

  // Propiedades para el formulario
  nombres: string = '';
  apellidos: string = '';
  selectedContactType: string = '';
  contactInfo: string = '';
  selectedRequestType: string = '';
  comments: string = '';
  contactInfoError: string = '';
  isFormValid: boolean = false;
  clientId: string = environment.client_id;
  title: string = '';
  subtitle1: string = '';
  subtitle2: string = '';
  UserSatisfactionSurveyUrl: string = environment.satisfaction_survey_url;
  showNotification = false;
  notificationType: 'success' | 'error' = 'success';
  notificationTitle = '';
  notificationMessage = '';

  constructor(
    private menuInfoService: MenuInfoService,
    private authService: AuthService,
    private gAnalytics: GoogleAnalyticsService
  ) {}

  ngOnInit() {
    this.title = 'Comunica tu Experiencia';
    this.subtitle1 = 'Tu opinión es importante para nosotros';
    this.subtitle2 = 'Escribenos si deseas ser contactado:';

    this.cargarListas();
  }

  private cargarListas() {
    const user = this.authService.getUserId() || '';
    this.menuInfoService.getLists({ user }).subscribe({
      next: (response) => {
        if (response.StatusRequest === '200 OK') {
          this.tiposContacto = response.Structure.filter(
            (item) => item.Keyword === 'ContactType'
          );

          this.tiposSugerencia = response.Structure.filter(
            (item) => item.Keyword === 'SuggestionTypesInter365'
          );
        }
      },
      error: (error) => {
        console.error('Error al cargar las listas:', error);
      },
    });
  }

  // Validar el formulario
  validateContactInfo(): void {
    if (!this.selectedContactType || !this.contactInfo) {
      this.contactInfoError = 'Este campo es requerido';
      this.isFormValid = false;
      return;
    }

    if (this.selectedContactType === '1') {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (!emailPattern.test(this.contactInfo)) {
        this.contactInfoError = 'Formato de correo electrónico inválido';
        this.isFormValid = false;
        return;
      }
    }

    if (this.selectedContactType === '2' || this.selectedContactType === '3') {
      const phonePattern = /^\d{10}$/;
      if (!phonePattern.test(this.contactInfo)) {
        this.contactInfoError = 'El teléfono debe tener 10 dígitos';
        this.isFormValid = false;
        return;
      }
    }

    this.contactInfoError = '';
    this.isFormValid = true;
  }

  onSubmit() {
    if (!this.selectedContactType || !this.selectedRequestType) {
      this.mostrarNotificacion(
        'error',
        'Error',
        'Por favor complete todos los campos requeridos'
      );
      return;
    }

    const suggestion: SuggestionRequest = {
      clientCode: this.authService.getProducerNumber() || 0,
      firstName: this.authService.getUsername() || '',
      lastName: this.authService.getUsername() || '',
      contactTypeID: parseInt(this.selectedContactType),
      contact: this.contactInfo,
      suggestionTypeID: parseInt(this.selectedRequestType),
      description: this.comments,
      idChannel: 22,
      clientId: this.clientId,
    };

    this.gAnalytics.trackEvent('formulario_contacto_enviado',{
        page:'/buzon',
        tipo_contacto:this.tiposContacto.find(tc => tc.Code === this.selectedContactType)?.Description || '',
        tipo_solicitud:this.tiposSugerencia.find(ts => ts.Code === this.selectedRequestType)?.Description || '',
        action:'Buzon de sugerencia enviado'
      })


    this.menuInfoService.sendSuggestion(suggestion).subscribe({
      next: (response) => {
        if (response.statusCode === 200) {
          this.mostrarNotificacion(
            'success',
            '¡Éxito!',
            'Sugerencia enviada exitosamente'
          );
          this.resetForm();
        } else {
          this.mostrarNotificacion(
            'error',
            'Error',
            'Error al enviar la sugerencia. Por favor intente nuevamente.'
          );
        }
      },
      error: (error) => {
        console.error('Error al enviar sugerencia:', error);
        this.mostrarNotificacion(
          'error',
          'Error',
          'Error al enviar la sugerencia. Por favor intente nuevamente.'
        );
      },
    });
  }

  public resetForm() {
    this.nombres = '';
    this.apellidos = '';
    this.selectedContactType = '';
    this.contactInfo = '';
    this.selectedRequestType = '';
    this.comments = '';
    this.contactInfoError = '';
    this.isFormValid = false;
  }

  onContactTypeChange() {
    this.contactInfo = '';
    this.contactInfoError = '';
    this.isFormValid = false;
    this.validateForm();
  }

  onContactInfoChange() {
    this.validateContactInfo();
    this.validateForm();
  }

  validateNumberOnly(event: KeyboardEvent): void {
    if (this.selectedContactType === '2' || this.selectedContactType === '3') {
      // Teléfono y celcular
      if (
        !/^\d*$/.test(event.key) &&
        event.key !== 'Backspace' &&
        event.key !== 'Tab'
      ) {
        event.preventDefault();
      }
    }
  }

  mostrarNotificacion(
    type: 'success' | 'error',
    title: string,
    message: string
  ) {
    this.notificationType = type;
    this.notificationTitle = title;
    this.notificationMessage = message;
    this.showNotification = true;

    setTimeout(() => {
      this.showNotification = false;
    }, 5000);
  }

  validateForm(): void {
    this.isFormValid =
      !!this.selectedContactType &&
      !!this.contactInfo &&
      !!this.selectedRequestType &&
      !!this.comments &&
      !this.contactInfoError;
  }
}
